import script from "./FormPriceInput.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPriceInput.vue?vue&type=script&setup=true&lang=js"

import "./FormPriceInput.vue?vue&type=style&index=0&id=759ef328&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-759ef328"]])

export default __exports__